import {
  // CLEAR_EVENT,
  DELETE_EVENT,
  DELETE_EVENT_ERROR,
  DELETE_EVENT_SUCCESS,

  GET_EVENT,
  GET_EVENT_ERROR,
  GET_EVENT_SUCCESS,

  SAVE_EVENT,
  SAVE_EVENT_ERROR,
  SAVE_EVENT_SUCCESS,

  GET_ALL_EVENT,
  GET_ALL_EVENT_ERROR,
  GET_ALL_EVENT_SUCCESS,

} from './constants';

export default {

  [DELETE_EVENT](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_EVENT_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_EVENT_SUCCESS](state) {
    state.account = false;
    state.loading = false;
  },

  [GET_EVENT](state) {
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_EVENT_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_EVENT_SUCCESS](state, payload) {
    state.singleEvent = payload;
    state.loading = false;
    state.success = true;
  },

  [SAVE_EVENT](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
    state.eventCreated = 0;
  },
  [SAVE_EVENT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_EVENT_SUCCESS](state, payload) {
    state.events = payload;
    state.formLoading = false;
    state.success = true;
    state.eventCreated = payload;
  },

  [GET_ALL_EVENT](state) {
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_ALL_EVENT_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ALL_EVENT_SUCCESS](state, payload) {
    state.events = payload;
    state.loading = false;
    state.success = true;
  },

  // single object item mutation
  // updateItem(state, payload) {
  //   state.events[payload.item] = payload.value;
  // },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Calendar/mutations.js